import React, { useState } from 'react';
import logo from '../assets/logo.png'; // Asegúrate de que la ruta del logo sea correcta
import { Link } from 'react-router-dom'; // Importa Link de React Router

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bg-white shadow-md fixed w-full z-20 top-0 left-0">
      <div className="container mx-auto flex items-center justify-between h-16 md:h-20 px-4">
        {/* Logo */}
        <div className="flex items-center">
          <Link to="/">
            <img src={logo} alt="Lorenzo Vaquer" className="h-10 md:h-14" />
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button type="button" className="text-blue-500 hover:text-blue-700 focus:outline-none" onClick={toggleMenu}>
            <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
            </svg>
          </button>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-6">
          <ul className="text-lg font-bold text-blue-500 flex space-x-6">
            <li><Link to="/perforaciones" className="hover:text-blue-700 cursor-pointer">PERFORACIONES</Link></li>
            <li><Link to="/desarrollo" className="hover:text-blue-700 cursor-pointer">DESARROLLO Y BOMBA</Link></li>
            <li><Link to="/compresor" className="hover:text-blue-700 cursor-pointer">COMPRESOR</Link></li>
            <li><Link to="/historia" className="hover:text-blue-700 cursor-pointer">NUESTRA HISTORIA</Link></li>
            <li><Link to="/contacto" className="hover:text-blue-700 cursor-pointer">CONTACTO</Link></li>
          </ul>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white shadow-lg absolute top-16 left-0 w-full">
          <ul className="flex flex-col items-center py-4 space-y-4 text-lg font-semibold text-blue-500">
            <li><Link to="/perforaciones" className="hover:text-blue-700 cursor-pointer" onClick={toggleMenu}>PERFORACIONES</Link></li>
            <li><Link to="/desarrollo" className="hover:text-blue-700 cursor-pointer" onClick={toggleMenu}>DESARROLLO Y BOMBA</Link></li>
            <li><Link to="/compresor" className="hover:text-blue-700 cursor-pointer" onClick={toggleMenu}>COMPRESOR</Link></li>
            <li><Link to="/nuestra-historia" className="hover:text-blue-700 cursor-pointer" onClick={toggleMenu}>NUESTRA HISTORIA</Link></li>
            <li><Link to="/contacto" className="hover:text-blue-700 cursor-pointer" onClick={toggleMenu}>CONTACTO</Link></li>
          </ul>
        </div>
      )}
    </nav>
  );
}

export default Navbar;